module.exports = __webpack_public_path__ + "img/67.1f955d54.jpg";